import * as S from "./styled"

export const FormError = ({ error, align = "left" }) => {
  if (error) return <S.Error $align={align}>{error}</S.Error>
  return null
}
